import { render, staticRenderFns } from "./ProfileReviewsDialog.vue?vue&type=template&id=a3e5a060&scoped=true&"
import script from "./ProfileReviewsDialog.vue?vue&type=script&lang=js&"
export * from "./ProfileReviewsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProfileReviewsDialog.vue?vue&type=style&index=0&id=a3e5a060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e5a060",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VFadeTransition,VIcon})
